import * as React from 'react';
import { Button } from '@cian/ui-kit';

interface IProps {
  onConfirm(): void;
  onCancel(): void;
}

export function ModalFooter({ onConfirm, onCancel }: IProps) {
  return (
    <React.Fragment>
      <Button size="XS" theme="fill_white_primary" onClick={onCancel}>
        Отменить
      </Button>
      <Button size="XS" onClick={onConfirm}>
        Удалить
      </Button>
    </React.Fragment>
  );
}
